import DefaultLayout from "@/layouts/DefaultLayout";
import KPurchaseOrderErrorForm from "kinnect-front/Sales/PurchaseOrders/KPurchaseOrderErrorForm";
import KSalesOrderErrorForm from "kinnect-front/Sales/SalesOrders/KSalesOrderErrorForm";
import KTripErrorForm from "kinnect-front/KYard/Trips/KTripErrorForm";
import {
	Crudable,
	FetchesData,
	Pageable
} from "kinnect-mixins";
import {
	KActionDialog,
	KSelect
} from "kinnect-general";
import {
	VAlert,
	VCard,
	VCardText,
	VCardTitle
} from "vuetify/lib";
import { YardTrip, YardTripError } from "kinnect-models";

export default {
	name: "YardTripErrorPage",

	metaInfo: { title: "Yard - Trips - Add an Error" },

	props: {
		idTrip: {
			required: true,
			type: Number
		},
		idError: Number
	},

	mixins: [
		Crudable,
		FetchesData,
		Pageable
	],

	data: () => ( {
		crud: "yard_trip_errors",
		deleteDialogOpen: false,
		errorType: null,
		errorTypes: [
			{
				text: "Purchase Order",
				value: "purchaseOrder"
			},
			{
				text: "Sales Order",
				value: "salesOrder"
			},
			{
				text: "Trip",
				value: "trip"
			}
		],
		formWidth: "800px",
		selectWidth: "400px",
		trip: null,
		tripError: null
	} ),

	computed: {
		editing() {
			return Boolean( this.idError );
		},

		genDeleteDialog() {
			if ( this.tripError && this.canDelete ) {
				return <KActionDialog
					confirmButtonColor="error"
					confirmButtonText="Delete"
					loading={this.$wait.is( "delete trip error" )}
					onConfirm={() => this.deleteError()}
					redirect={[ "back", {
						name: "yardTrip",
						params: { idTrip: this.idTrip }
					} ]}
					title="Delete Trip Error"
					vModel={this.deleteDialogOpen}
				>
					Are you sure you want to delete this trip error?
				</KActionDialog>;
			}
		},

		toolbarActions() {
			if ( this.canDelete ) {
				return {
					icon: "delete",
					onClick: () => this.deleteDialogOpen = true,
					text: "Delete",
					tooltip: "Delete this trip error"
				};
			}
		},

		genErrorSelectField() {
			return <KSelect
				items={this.errorTypes}
				label="Error Associated with"
				loading={this.$wait.is( "find trip" )}
				outline
				vModel={this.errorType}
			></KSelect>;
		},

		genErrorForm() {
			switch ( this.errorType ) {
				case "purchaseOrder":
					return this.trip.purchaseOrders.length
						? <KPurchaseOrderErrorForm
							formTitle="Add a Purchase Order Error"
							key="purchase-order-error-form"
							purchaseOrdersTableProps={{
								items: this.trip.purchaseOrders,
								showSelect: true
							}}
						></KPurchaseOrderErrorForm>
						: <VAlert
							class="brown--text"
							key="no-purchase-order-error-form"
							type="warning"
							value
						>There are no purchase orders for this trip</VAlert>;

				case "salesOrder":
					return this.trip.salesOrders.length
						? <KSalesOrderErrorForm
							formTitle="Add a Sales Order Error"
							key="sales-order-error-form"
							salesOrdersTableProps={{
								items: this.trip.salesOrders,
								showSelect: true
							}}
						></KSalesOrderErrorForm>
						: <VAlert
							class="brown--text"
							key="no-sales-order-error-form"
							type="warning"
							value
						>There are no sales orders for this trip</VAlert>;

				case "trip":
					return this.genTripErrorForm;
			}
		},

		genTripErrorForm() {
			return <KTripErrorForm
				formTitle={this.editing ? "Edit Trip Error" : "Add a Trip Error"}
				idTrip={this.idTrip}
				key="trip-error-form"
				loading={this.$wait.is( "find trip error" )}
				tripError={this.tripError}
			></KTripErrorForm>;
		}
	},

	methods: {
		deleteError() {
			const trip = new YardTrip( { id: this.idTrip } );

			return this.tripError
			.for( trip )
			.delete();
		},

		async fetchError() {
			if ( this.editing ) {
				this.tripError = await new YardTripError()
				.for( new YardTrip( { id: this.idTrip } ) )
				.findPageModel( this.idError );
			}
		},

		async fetchTrip() {
			this.trip = await YardTrip
			.include(
				"schedules.purchase-orders",
				"schedules.sales-orders"
			)
			.findPageModel( this.idTrip );
		},

		async fetch() {
			await this.$http.all( [
				this.fetchError(),
				this.fetchTrip()
			] );
		}
	},

	render() {
		if ( this.editing ) {
			return <DefaultLayout maxWidth={this.formWidth}>
				{this.genTripErrorForm}
				{this.genDeleteDialog}
			</DefaultLayout>;
		}

		return <transition
			mode="out-in"
			name="slide-y-transition"
		>
			{this.errorType
				? <DefaultLayout
					key="error-type-selected"
					maxWidth={this.formWidth}
				>
					{this.genErrorSelectField}

					<transition
						mode="out-in"
						name="slide-y-transition"
					>
						{this.genErrorForm}
					</transition>
				</DefaultLayout>

				: <DefaultLayout
					key="error-type-unselected"
					maxWidth={this.selectWidth}
				>
					<VCard key="error-type-unselected">
						<VCardTitle class="text-subtitle-1 primary white--text">
							Select Error Association
						</VCardTitle>

						<VCardText>
							{this.genErrorSelectField}
						</VCardText>
					</VCard>
				</DefaultLayout>
			}
		</transition>;
	}
};
